import fullChartDates from '@/helpers/chart/fullChartDates';
import fullChartHours from '@/helpers/chart/fullChartHours';

const ChartHelper = {
    fullChartDates,
    fullChartHours
};

export default ChartHelper;